import React from 'react';
import PropTypes from 'prop-types';
import GenericAlert from '../../../../commons/GenericAlert';

export default function Violations({ importer }) {
  return (
    <>
      {Object.keys(importer?.response?.records)
        .map((record) => importer.response.records[record]
          .map((alert) => <GenericAlert key={`${record}${alert}`} alertText={`${record}: ${alert}`} type="alert" />))}

      {importer?.response?.violations
        .map((violation) => <GenericAlert key={violation} alertText={violation.message} type="alert" />)}
    </>
  );
}

Violations.propTypes = {
  importer: PropTypes.shape({
    response: PropTypes.objectOf(PropTypes.any),
    isLoading: PropTypes.bool,
  }).isRequired,
};
